var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"warpper",style:([{bottom:_vm.bottom+'px'},{top:(_vm.top=='none'?0:_vm.top+'px')},{backgroundColor:_vm.bg}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }